import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/siteInfo';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-search-line text-lg text-background-50"></i>
              </div>
              <span className="text-xl font-bold font-heading text-background-50">
                番号吧
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              {siteInfo.tagline}。收录超过
              <strong className="text-background-200">
                {(siteInfo.stats.totalArticles / 10000).toFixed(0)}万
              </strong>
              条番号信息，每日更新最新内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              分类浏览
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              快捷链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/category/latest"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  最新发布
                </Link>
              </li>
              <li>
                <Link
                  to="/category/hot"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  热门推荐
                </Link>
              </li>
              <li>
                <Link
                  to="/category/featured"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  精选合集
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span>每日更新 · 全年无休</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <p className="text-xs text-background-500">
            本站仅供信息检索参考，不提供影片播放与下载服务
          </p>
        </div>
      </div>
    </footer>
  );
}